import { useEffect } from "react";
import { t } from "@/i18n-js/instance";
import { usePunditUserContext } from "@/react/contexts";
import { useEventsTracker } from "@/react/hooks/analytics/useEventsTracker";
import { usePlanPageVariant } from "@/react/hooks/usePlanPageVariant";
import { usePlans } from "@circle-react/components/SettingsApp/Plan/RegularPlan/PlansContext";
import { classNames } from "@circle-react/helpers/twMergeWithCN";
import { Loader } from "@circle-react-uikit/Loader";
import Features from "../Features";
import { PlanSelector } from "../PlanSelector";
import { TopSection } from "../TopSection";
import { PlanSummary } from "./PlanSummary";
import socialProof from "./socialProof.svg";

const localeRoot = "pricing_plans.plan_settings.plan_selection";

export const PlanSelectorVariantC = () => {
  const { isLoading: isCurrentCommunityLoading } = usePunditUserContext();
  const { isCurrentPlanLoading } = usePlans();
  const { isExperimentTabLayout } = usePlanPageVariant();

  const { trackEvent } = useEventsTracker();

  useEffect(() => {
    trackEvent("plan_settings.plans_page.visited", {});
  }, [trackEvent]);

  if (isCurrentPlanLoading || isCurrentCommunityLoading) {
    return <Loader variant="fullscreen" />;
  }

  const featuresAndProof = (
    <>
      <img src={socialProof} loading="lazy" alt={t([localeRoot, "title"])} />
      <Features />
    </>
  );

  return (
    <div className="flex flex-col gap-10">
      <TopSection />
      <div className="flex gap-6">
        <div
          className={classNames(
            "flex flex-col gap-10",
            isExperimentTabLayout ? "w-[550px]" : "w-[681px]",
          )}
        >
          <PlanSelector />
          {!isExperimentTabLayout && featuresAndProof}
        </div>
        <div>
          <PlanSummary />
        </div>
      </div>
      {isExperimentTabLayout && (
        <div className="mx-auto flex max-w-[681px] flex-col gap-y-6">
          {featuresAndProof}
        </div>
      )}
    </div>
  );
};
